import cn from 'classnames';
import React, { memo } from 'react';

import { Carousel } from '@sravni/react-design-system/lib/Carousel';
import getProperty from '@sravni/vitrina/lib/helpers/getProperty';
import type IStringTabRowConfig from '@sravni/vitrina/lib/types/config/details/IStringTabRowConfig';
import type IProduct from '@sravni/vitrina/lib/types/IProduct';

import type ITabDetail from '@components/RatingTable/components/ProductPopup/interfaces/ITabDetail';

import { useDictionaries, useProductConfig } from '../../../../../../store/hooks/productPopupInfo';

import styles from './CarouselRow.module.scss';
import { useCarouselProperties } from './hooks';

interface IProps {
  config: ITabDetail;
  additionalInformationClassName?: string;
  product: IProduct;
  rowClassName?: string;
}

const CarouselRow: React.FC<IProps> = memo((props: IProps) => {
  const dictionaries = useDictionaries();
  const { config, product } = props;
  const vitrinsConfig = useProductConfig();

  const { items, groupKeys = [], setActiveKey, activeKey } = useCarouselProperties(product, config);

  return (
    <div>
      <div className={styles.group}>
        {groupKeys.map(({ label, value }: any) => (
          <span
            className={cn(styles.tag, activeKey === value && styles.active)}
            onClick={() => setActiveKey(value)}
            key={value}
          >
            {label}
          </span>
        ))}
      </div>
      <div>
        {!!activeKey && (
          <Carousel bottomControls>
            {items.map((item) => (
              <div key={item[config.carousel.imagePropertyName]}>
                <img className={styles.image} width={260} src={item[config.carousel.imagePropertyName]} />
                {item[(config.carousel.title as IStringTabRowConfig).property] && (
                  <div className={styles.title}>
                    {getProperty(vitrinsConfig, config.carousel.title, item, dictionaries)}
                  </div>
                )}
                {item[(config.carousel.description as IStringTabRowConfig).property] && (
                  <div className={styles.description}>
                    {getProperty(vitrinsConfig, config.carousel.description, item, dictionaries)}
                  </div>
                )}

                <div className={styles.hint}>
                  {getProperty(vitrinsConfig, config.carousel.hint, item, dictionaries)}
                </div>
              </div>
            ))}
          </Carousel>
        )}
      </div>
    </div>
  );
});

export default CarouselRow;
